import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

/**
 * Superficie premium para envolver formularios (pago, cliente, sesión, etc.).
 * off-black (`surface.content`) + hairline + sombra teñida + radio 16, según DESIGN_SYSTEM §6/§13.
 * Da estructura y un look profesional sin tocar los campos. Botones van fuera (debajo).
 */
function FormSurface({ title = '', subtitle = '', children }) {
  return (
    <>
      {(title || subtitle) && (
        <Box sx={{ mb: 2 }}>
          {title && (
            <Typography variant="h6" sx={{ fontWeight: 800, color: 'text.primary', letterSpacing: '-0.01em' }}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
      <Box
        sx={{
          p: { xs: 2.5, md: 3.5 },
          borderRadius: '16px',
          backgroundColor: 'surface.content',
          border: '1px solid',
          borderColor: 'hairline.main',
          boxShadow: 'inset 0 1px 0 var(--otx-inner-highlight), var(--otx-card-shadow)'
        }}>
        {children}
      </Box>
    </>
  );
}

FormSurface.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default FormSurface;
